<template>
    <div class="orderitems" @click="gotoOrderInfo">
        <!-- 内容 -->
        <div class="orderitems-message">
            <van-image />
            <div class="content">
                <div class="status">
                    <span class="un" v-if="row.status == 1">待支付</span>
                    <span class="un" v-else-if="row.status == 2">待发货</span>
                    <span class="un" v-else-if="row.status == 3">待收货</span>
                    <!-- 待评价 -->
                    <span v-else-if="row.status == 4">已完成</span>
                    <span v-else-if="row.status == 0">已取消</span>
                </div>
                <div class="content-title-price-num">
                    <div class="title">
                        <div class="tit">{{ row.goods_name }}</div>
                        <div class="info myInfo">
                            <div class="info_item" v-for="(item2, i) in row.goodsGroupItem" :key="i">{{ item2.gift_name }}&nbsp;
                            </div>
                        </div>
                    </div>
                    <div class="price-and-num">
                        <div class="price">&yen;&nbsp;{{ row.price }}</div>
                        <div class="num">&times;{{ row.num }}</div>
                    </div>
                </div>


            </div>
        </div>
        <!-- 实际付款 -->
        <div class="orderitems-price">
            <div :class="{ 'right': true, 'right2': row.discount_price && row.discount_price != '0.00' }">
                <div v-if="row.discount_price && row.discount_price != '0.00'">
                    <div v-if="row.roll_deduct_price && row.roll_deduct_price != '0.00'">
                        <span class="dk_words">抵扣券抵扣&nbsp;&nbsp;</span><span class="money_num">-&nbsp;&yen;{{
                            row.roll_deduct_price }}</span>
                    </div>
                    <div v-if="row.point_deduct_price && row.point_deduct_price != '0.00'">
                        <span class="dk_words">积分抵扣&nbsp;&nbsp;</span><span class="money_num">-&nbsp;&yen;{{
                            row.point_deduct_price }}</span>
                    </div>
                </div>
                <div>
                    <span class="fk_suffix">实付款&nbsp;&nbsp;&nbsp;</span>
                    <span class="money_num">&yen;</span>
                    <span class="afterPrice money_num2">{{ row.price }}</span> 
                    <span v-if="row.logisticsFlag">&nbsp;(&nbsp;免运费&nbsp;)</span>
                </div>
            </div>
        </div>
        <!-- 按钮 -->
        <div class="paybuttons">
            <div class="btns">
                <van-button type="default" size="small" v-if="row.cdk&&row.cdk.cdk.length != 0" @click.stop="copyCdk(row.cdk)">查看CDK
                </van-button>
                <van-button type="default" size="small" v-if="row.status == 1" @click.stop="cancel">取消订单</van-button>
                <!-- <van-button type="default" size="small" v-if="item.status == 2">删除订单</van-button> -->
                <!-- <van-button type="default" size="small" v-if="item.status == 3">查看物流</van-button>-->

                <van-button class="active" size="small" v-if="row.status == 1" :disabled="row.disabled">
                    付款
                    <van-count-down :time="new Date(new Date(row.create_time.replace(/-/g, '/'))).getTime() + 900000 - new Date(now).getTime()" format="mm:ss" @finish="finish"></van-count-down>
                </van-button>
                <!-- <van-button type="default" size="small" color="#d9b581" v-if="item.status == 2">再次购买</van-button> -->
                <van-button class="active" size="small" v-if="row.status == 3">确认收货</van-button>
                <!-- <van-button type="default" size="small" v-if="row.status == 4">申请退款</van-button> -->
                <van-button class="active" size="small" v-if="row.status == 0||row.status == 2||row.status == 3||row.status == 4" @click.stop="buy(row.goods_id)">{{ row.status == 0?'重新购买':'再次购买' }}</van-button>
                <!-- <van-button type="default" size="small" color="#d9b581" v-if="item.status == 4">立即评价</van-button> -->
                <!-- <button @click="gotoWorkOrder">123</button> -->
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { Dialog } from 'vant';
export default {
    computed: {
        active() {
            return this.$route.params.active;
        },
        row() {
            return this.$parent.$props.row || {};
        },
        isMobileWechat() {
            var system = {
                win: false,
                mac: false,
                xll: false,
                ipad: false
            };
            //检测平台
            var p = navigator.platform;
            system.win = p.indexOf("Win") == 0;
            system.mac = p.indexOf("Mac") == 0;
            system.x11 = p == "X11" || p.indexOf("Linux") == 0;
            system.ipad = navigator.userAgent.match(/iPad/i) != null ? true : false;
            if (system.win || system.mac || system.xll || system.ipad) { } else {
                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    return true;
                } else {
                    return false;
                }
            }
        },
        //服务器时间
        now() {
            return new Date(new Date().valueOf() - this.$store.state.differTime)
        }
    },
    data() {
        return {
            showcd: true
        }
    },
    methods: {
        gotoOrderInfo() {
            this.$router.push({
                name: 'order.detail',
                query: {
                    order_num: this.row.order_num
                }
            })  
        },
        copyCdk(cdk) {
            this.$RModal.copyCdk({
                hasfooter: false,
                title: cdk.name,
                selection: {
                    cdk
                }
            })
        },
        finish() {
            this.$set(this.row,'status',0)
        },
        //取消订单
        cancel() {
            Dialog.confirm({
              closeOnClickOverlay: true,
              closeOnPopstate: true,
              message: "您确定要取消订单吗？"
            }).then(() => {
                this.$Ajax('market-order/cancel-order',{
                    orderNum: this.row.order_num
                }).then(rs => {
                    if(rs.code == 200) {
                        this.$parent.$parent.$parent.refresh()
                        this.$toast(rs.msg)
                    }
                })
            }).catch(() => {
                // on cancel
            })
        },
        buy(goods_id) {
            this.$router.push({
                name: 'shop.detail',
                params: { id: goods_id },
            })
        }
    },
}
</script>

<style lang="less" scoped>
.orderitems {
    padding: .6rem;
    background-color: #fff;
    margin-bottom: .6rem;
    border-radius: .7rem;

    .orderitems-message {
        display: flex;

        /deep/.van-image {
            margin-right: .75rem;
            position: relative;
            width: 3.4rem;
            height: 3.4rem;

            img {
                border-radius: .4rem;
                width: 100%;
                height: 100%;
                overflow: hidden;
            }

            .van-image__loading {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }
        }

        .content {
            flex: 1;
            margin-bottom: .8rem;
            .status {
                display: flex;
                justify-content: flex-end;
                font-size: .6rem;
                color: #9e9e9e;
                margin-bottom: 13px;
                .un {
                    color: #670000;
                    font-weight: 700;
                }
            }

            .content-title-price-num {
                display: flex;
                justify-content: space-between;

                .title {
                    .tit {
                        word-break: break-all;
                        color: #000;
                        font-weight: 700;
                        font-size: .7rem;
                        margin-bottom: .6rem;
                    }

                    .myInfo {
                        .info_item {
                            color: #9e9e9e;
                            font-size: .6rem;
                            line-height: 0.8rem;
                            word-break: break-all;
                        }
                    }
                }

                .price-and-num {
                    .price {
                        color: #000;
                        font-size: .7rem;
                        font-weight: 700;
                        margin-bottom: .4rem;
                        text-align: end;
                    }
                    .num {
                        text-align: end;
                    }
                }
            }
        }
    }
    .orderitems-price {
        margin-bottom: .95rem;
        text-align: end;
        .fk_suffix {
            color: #000;
            font-weight: 700;
            font-size: .6rem;
        }
        .afterPrice,
        .money_num {
            color: #670000;
            font-weight: 700;
        }
    }
    .paybuttons {
        .btns {
            display: flex;
            justify-content: flex-end;
            /deep/.van-button {
                margin-left: 1.25rem;
                width: 4.5rem;
                height: 1.4rem;
                border-radius: 10rem;
                line-height: 1.4rem;
                color: #9e9e9e;
                background-color: #F3F2F2;
                font-size: .6rem;
                border: none;
                &:nth-child(1) {
                    margin-left: 0;
                }
                &.active {
                    background-color: #ECD7D5;
                    color: #670000;
                    &:active {
                        &::before {
                            background-color: #ff9a93;
                            color: #250000;
                        }
                        
                    }
                }
                .van-button__text {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .van-count-down {
                    font-size: .6rem;
                    color: #670000;
                }
            }
        }
    }
}</style>